module.exports = __webpack_public_path__ + "static/img/one.b15de24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-eight/one.png
// module id = ZRI0
// module chunks = 0